import React from 'react';
import * as FiIcons from 'react-icons/fi';
import HighlightText from './HighlightText';

const { FiCheckCircle, FiClock, FiRefreshCw, FiAward } = FiIcons;

const features = [
  {
    icon: FiCheckCircle,
    title: '100% Verified Tutors',
    desc: 'Every tutor goes through a strict background check and verification process.'
  },
  {
    icon: FiClock,
    title: 'Flexible Timings',
    desc: "Schedule classes according to your child's convenience and availability."
  },
  {
    icon: FiRefreshCw,
    title: 'Easy Replacement',
    desc: 'Not satisfied? Get a replacement tutor without any extra charges.'
  },
  {
    icon: FiAward,
    title: 'Quality Education',
    desc: 'Our tutors are experienced professionals committed to improving grades.'
  }
];

const AboutUs = () => {
  return (
    <section className="py-24 bg-white overflow-hidden" id="about">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Left Side - Text & Features */}
          <div className="space-y-10">
            <div>
              <h2 className="text-3xl md:text-[2.5rem] font-extrabold text-slate-900 leading-[1.2] tracking-tight mb-4">
                Why Choose <HighlightText>MyHomeTutors?</HighlightText>
              </h2>
              <p className="text-gray-500 text-lg font-medium leading-relaxed max-w-lg">
                We Connect You With Only The Best Tutors In Your Area
              </p>
            </div>

            <div className="space-y-8">
              {features.map((feature, idx) => (
                <div key={idx} className="flex gap-5 group">
                  <div className="flex-shrink-0 mt-1">
                    <div className="w-14 h-14 bg-red-50 rounded-2xl flex items-center justify-center group-hover:bg-primary group-hover:scale-110 transition-all duration-300 shadow-sm">
                      <feature.icon className="w-6 h-6 text-primary group-hover:text-white transition-colors duration-300" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-extrabold text-slate-900 mb-2 tracking-tight">{feature.title}</h3>
                    <p className="text-gray-600 text-base leading-relaxed font-medium">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Side - Image Layout */}
          <div className="relative w-full max-w-lg mx-auto lg:mx-0 mt-10 lg:mt-0">
            {/* Main Image Container */}
            <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden shadow-2xl border-4 border-white z-10">
              <img
                src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=800&q=80"
                alt="Student studying with tutor"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>

            {/* Decorative Background Shapes */}
            <div className="absolute top-10 -right-10 w-full h-full border-2 border-red-100 rounded-[2rem] -z-0"></div>
            <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-orange-50 rounded-full blur-2xl -z-10"></div>
            <div className="absolute -top-8 -right-8 w-40 h-40 bg-red-50 rounded-full blur-3xl -z-10"></div>

            {/* Floating Trust Badge */}
            <div className="absolute bottom-10 -left-12 bg-white p-5 rounded-2xl shadow-xl border border-gray-100 flex items-center gap-4 z-20 animate-[bounce_4s_infinite]">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                <FiAward className="text-green-600 w-6 h-6" />
              </div>
              <div>
                <div className="text-2xl font-extrabold text-slate-900 leading-none mb-1">10k+</div>
                <div className="text-xs font-bold text-gray-500 uppercase tracking-widest">Happy Students</div>
              </div>
            </div>
            
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutUs;